@if (!authKeyLogin) {
  <form [formGroup]="mainForm" (ngSubmit)="login()">
    <lgd-text controlName="username" label="Username" class="login-field">
    </lgd-text>
    <lgd-password controlName="password" label="Password" class="login-field" autocomplete="current-password">
    </lgd-password>
    @if (showRememberMe) {
      <div class="tt-margin--bottom">
        <lgd-checkbox controlName="rememberMe" label="Remember me">
        </lgd-checkbox>
      </div>
    }
    <div fxLayout="column" fxLayoutAlign="space-between stretch" class="login-button-container">
      <forge-button [disabled]="submitDisabled" type="submit" variant="raised" full-width>
        @if (!loading) {
          <span>Sign in</span>
        } @else {
          <forge-circular-progress diameter="30">
          </forge-circular-progress>
        }
      </forge-button>
      @if (allowForgetPassword) {
        <forge-button full-width [disabled]="forgotPasswordDisabled"
          (click)="switchToForgotPassword()">
          Forgot password
        </forge-button>
      }
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="error-container">
      <div class="forge-typography--subheading1">
        {{error}}
      </div>
    </div>
  </form>
}

